import { authFormPost, authPost, doPost } from "../../common/redux/ApiClient";

const baseUrl = "35.240.204.237/es3KioskApi";

export function checkGroupCredit(params) {
  return authPost(`${baseUrl}/Agent1.ashx`, params);
}
